const bar = document.querySelector('[data-sticky-models]');

if (bar) {
    const SCROLL_TRIGGER = 600;

    const setState = (state) => {
        bar.dataset.state = state;
        document.body.classList.remove(
            'has-sticky-models-collapsed',
            'has-sticky-models-expanded'
        );
        if (state === 'collapsed') {
            document.body.classList.add('has-sticky-models-collapsed');
        } else if (state === 'expanded') {
            document.body.classList.add('has-sticky-models-expanded');
        }
    };

    // Scroll trigger → show expanded
    let triggered = false;
    const onScroll = () => {
        if (!triggered && window.scrollY > SCROLL_TRIGGER) {
            triggered = true;
            setState('expanded');
        }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    // Scroll active pill into view on mobile
    const activePill = bar.querySelector('.sticky-models__item.is-current');
    if (activePill) {
        activePill.scrollIntoView({ inline: 'center', block: 'nearest' });
    }

    // Expand/collapse toggle
    bar.querySelector('[data-sticky-expand]')?.addEventListener('click', () => {
        const current = bar.dataset.state;
        setState(current === 'expanded' ? 'collapsed' : 'expanded');
    });
}
